import useEventListeners from '@makeabledk/vue-ui/composables/event-listeners'

export default function useKeyboardNavigationClass(target = 'body', keyboardActiveClass = '--keyboard-navigation') {
    const events = useEventListeners()

    if (typeof target === 'string') {
        target = document.querySelector(target)
    }

    events.listen(
        document,
        'keyup',
        (event) => {
            if (['Tab', 'Enter', 'Esc', 'Escape'].indexOf(event.key) > -1) {
                target.classList.add(keyboardActiveClass)
            }
        },
        true // capture
    )

    events.listen(document, 'mousedown', () => {
        target.classList.remove(keyboardActiveClass)
    })
}
